// extracted by mini-css-extract-plugin
export default {"box":"AddressForm_box__LLva9","country":"AddressForm_country__oBcIu","ltr":"AddressForm_ltr__9F758"};